/* ==========================================================================
   DIANDA TRAVEL — Contact 联系我们页面交互脚本
   页面定位：找得到人（在线聊天 / 电话回拨 / WhatsApp / 邮件）
   ==========================================================================
   设计原则：
   - 无依赖、轻量
   - 所有查询都限定在 .dd-contact 内，避免污染其他页面
   - 只做 transform / opacity 类动效，避免重排
   - 未启用 JS 时：区号下拉与提交按钮都不可用（选项由 JS 注入、按钮是 type=button），其它联系方式仍可用
   ========================================================================== */
(function () {
  'use strict';

  /* 文案解码：t 过滤器会 HTML 转义译文（' → &#39;），经 json 内联进 JS 后需要还原 */
  function decodeEntities(value) {
    if (value == null || value === '') return '';
    var el = document.createElement('textarea');
    el.innerHTML = String(value);
    return el.value;
  }

  function decodeMessages(messages) {
    var out = {};
    var src = messages || {};
    for (var key in src) {
      if (Object.prototype.hasOwnProperty.call(src, key)) out[key] = decodeEntities(src[key]);
    }
    return out;
  }

  var root = document.querySelector('.dd-contact');
  if (!root) return;

  // Liquid → JS 的数据在 section 里直接内联，不走 data-* 中转
  var CONFIG = window.DDContactConfig || {};


  /* ------------------------------------------------------------------
     1. 滚动显现（IntersectionObserver）
        元素带 [data-reveal]，进入视口时淡入上移；无 JS 时由样式门控
     ------------------------------------------------------------------ */
  var revealItems = root.querySelectorAll('[data-reveal]');
  if (revealItems.length) {
    if (!('IntersectionObserver' in window)) {
      revealItems.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });

      revealItems.forEach(function (el) {
        var parent = el.parentElement;
        var siblings = Array.prototype.slice.call(parent ? parent.children : []).filter(function (c) {
          return c.hasAttribute('data-reveal');
        });
        var index = siblings.indexOf(el);
        if (index > 0) el.style.transitionDelay = (index % 4) * 70 + 'ms';
        observer.observe(el);
      });
    }
  }


  /* ------------------------------------------------------------------
     2. 国家区号下拉
        - 选项文案是「ISO 代码 (+区号)」，例如 CN (+86)，与首页留咨表单一致
        - 默认选中访客所在国家：优先 Shopify 判定，其次浏览器语言
        - 同步「国家名」到隐藏字段，方便客服回电前确认
     ------------------------------------------------------------------ */
  var countrySelect = root.querySelector('[data-dd-country-select]');

  function detectCountry() {
    if (CONFIG.customerCountry) return CONFIG.customerCountry;
    var lang = navigator.language || '';
    var m = lang.match(/[-_]([A-Za-z]{2})$/);
    return m ? m[1].toUpperCase() : '';
  }

  if (countrySelect) {
    // 选项来自共享区号表 assets/dd-country-codes.js（[区号, ISO, 名称]，已按名称 A→Z 排好），
    // 与留咨弹窗、首页共用一份数据；没拿到数据时下拉保持隐藏，号码仍可单独提交
    var countryData = window.DDCountryCodes || [];

    if (countryData.length) {
      var initialCountry = detectCountry();
      var frag = document.createDocumentFragment();

      countryData.forEach(function (row) {
        var option = document.createElement('option');
        option.value = row[0];
        option.setAttribute('data-iso', row[1]);
        option.setAttribute('data-name', row[2]);
        option.textContent = row[1] + ' (' + row[0] + ')';
        if (row[1] === initialCountry) {
          option.selected = true;
          // defaultSelected 也置上：form.reset() 会把下拉恢复成「默认项」，
          // 只设 selected 的话重置后会跳回列表第一项（Afghanistan）
          option.defaultSelected = true;
        }
        frag.appendChild(option);
      });

      countrySelect.innerHTML = '';
      countrySelect.appendChild(frag);
      countrySelect.parentNode.classList.add('is-ready'); // 有数据才显示下拉
    } else {
      console.error('[dd-contact] 未加载 assets/dd-country-codes.js，手机区号下拉未启用。');
    }
  }


  /* ------------------------------------------------------------------
     3. 电话回拨表单（JSON POST 到 Dianda 独立接口）
        - 输入时只保留合法字符
        - 提交体 { entry: 2, email, country_code, phone, message }，
          区号单独放 country_code，phone 只传号码本身（纯数字），
          message 取「回拨意图」下拉的选项文案
        - 号码不合法时前端拦截并给出提示
     ------------------------------------------------------------------ */
  var callbackForm = root.querySelector('#dd-contact-callback-form');

  if (callbackForm) {
    var phoneInput = callbackForm.querySelector('[data-dd-phone-input]');
    var phoneError = callbackForm.querySelector('[data-dd-phone-error]');
    var errorText = phoneError ? phoneError.textContent.trim() : '';
    var callCfg = window.ddContactCallConfig || {};
    var callMsgs = decodeMessages(callCfg.messages);
    var callStatus = callbackForm.querySelector('[data-dd-call-status]');
    var callSubmit = callbackForm.querySelector('.dd-callback__submit');
    var callSubmitHtml = callSubmit ? callSubmit.innerHTML : '';
    var callBusy = false;

    function currentDial() {
      if (!countrySelect) return '';
      var opt = countrySelect.options[countrySelect.selectedIndex];
      return opt ? opt.value : '';
    }

    function isValidPhone(value) {
      var digits = (value || '').replace(/\D/g, '');
      return digits.length >= 5 && digits.length <= 15;
    }

    function setPhoneError(message) {
      if (!phoneError) return;
      if (message) {
        phoneError.textContent = message;
        phoneError.hidden = false;
        if (phoneInput) phoneInput.setAttribute('aria-invalid', 'true');
      } else {
        phoneError.hidden = true;
        if (phoneInput) phoneInput.removeAttribute('aria-invalid');
      }
    }

    function showCallStatus(kind, text) {
      if (!callStatus) return;
      callStatus.hidden = !text;
      callStatus.className = 'dd-alert' + (kind ? ' dd-alert--' + kind : '');
      callStatus.textContent = text || '';
    }

    function setCallBusy(on) {
      callBusy = on;
      if (!callSubmit) return;
      callSubmit.disabled = on;
      // 忙时把「图标 + 文案」整体换成纯文字，结束后还原
      if (on) callSubmit.textContent = callMsgs.submitting || 'Sending…';
      else callSubmit.innerHTML = callSubmitHtml;
    }

    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        var cleaned = phoneInput.value.replace(/[^\d+\s().-]/g, '');
        if (cleaned !== phoneInput.value) phoneInput.value = cleaned;
        if (!phoneError || phoneError.hidden) return;
        if (isValidPhone(phoneInput.value)) setPhoneError('');
        else setPhoneError(errorText);
      });

      // 失焦只做校验，不提前改写用户输入：号码在提交时才取值
      phoneInput.addEventListener('blur', function () {
        if (!errorText) return;
        if (isValidPhone(phoneInput.value)) setPhoneError('');
      });
    }

    function submitCallback() {
      if (callBusy) return;

      // 每次提交先清掉上一次的提示（成功 / 失败 / 号码错误）
      showCallStatus('', '');
      setPhoneError('');

      // 按钮是 type=button，浏览器不会自动跑约束校验，这里手动触发（提示气泡与原生一致）
      if (callbackForm.reportValidity && !callbackForm.reportValidity()) return;

      var emailInput = callbackForm.querySelector('[name="contact[email]"]');
      var intentSelect = callbackForm.querySelector('[name="contact[intent]"]');
      var email = emailInput ? emailInput.value.trim() : '';
      var message = intentSelect ? intentSelect.value : '';
      var rawPhone = phoneInput ? phoneInput.value.trim() : '';
      var dial = currentDial();
      var digits = rawPhone.replace(/\D/g, '');

      // 用户直接输入国际号码（+86 138…）时，把已选区号从号码里剥掉，避免重复
      if (rawPhone.charAt(0) === '+') {
        var dialDigits = dial.replace(/\D/g, '');
        if (dialDigits && digits.indexOf(dialDigits) === 0) digits = digits.slice(dialDigits.length);
      }

      // 原生 required 已经拦过空值，这里兜住「只输入空格 / 符号」的情况
      if (!isValidPhone(digits) || !email) {
        setPhoneError(errorText);
        if (phoneInput) phoneInput.focus();
        return;
      }

      if (!callCfg.apiUrl) {
        // 静默失败会让用户以为按钮坏了，必须给出可见反馈
        console.error('[dd-contact] 未配置回拨接口地址，表单无法提交。');
        showCallStatus('error', callMsgs.error || 'Submission failed.');
        return;
      }

      setCallBusy(true);

      fetch(callCfg.apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          entry: callCfg.entry || 2,
          email: email,
          country_code: dial,
          phone: digits,
          message: message,
        }),
      })
        .then(function (res) {
          // 接口响应约定 {code, msg}，校验失败时还带 errors 数组；跨域被拦时
          // msg 会直接说明原因（"来源域名未被允许" = 当前域名不在白名单）
          return res.text().then(function (text) {
            var data = null;
            try { data = JSON.parse(text); } catch (_) {}
            var code = data && data.code != null ? Number(data.code) : null;
            if (res.ok && (code === null || code < 400)) return;
            var detail = data && data.errors && data.errors.length
              ? data.errors.join(' / ')
              : ((data && data.msg) || ('HTTP ' + res.status));
            var err = new Error(detail);
            err.serverMsg = detail;
            throw err;
          });
        })
        .then(function () {
          setCallBusy(false);
          // 成功后清空表单；reset() 会把区号恢复成默认项（访客国家）
          callbackForm.reset();
          showCallStatus('success', callMsgs.success || 'Thank you!');
        })
        .catch(function (err) {
          setCallBusy(false);
          showCallStatus('error', (err && err.serverMsg) || callMsgs.error || 'Submission failed.');
          console.error('[dd-contact] 回拨提交失败：', err);
        });
    }

    if (callSubmit) callSubmit.addEventListener('click', submitCallback);

    // 回车提交：表单现在没有 submit 按钮，浏览器通常不会隐式提交，这里手动接上
    callbackForm.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      var tag = event.target && event.target.tagName;
      if (tag !== 'INPUT') return; // textarea 里的回车是换行
      event.preventDefault();
      submitCallback();
    });

    // 双保险：万一还有别的路径触发表单提交，也不让它跳转
    callbackForm.addEventListener('submit', function (event) {
      event.preventDefault();
      submitCallback();
    });
  }

  // 表单提交后（无论成功或报错）把状态提示滚进视野，避免用户以为没反应。
  // 订阅表单的状态框默认 hidden，不能参与这里，否则页面加载就会被强行滚过去。
  var statusAlerts = Array.prototype.filter.call(root.querySelectorAll('.dd-alert'), function (el) {
    return !el.hidden;
  });
  if (statusAlerts.length) {
    var firstAlert = statusAlerts[0];
    try {
      firstAlert.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstAlert.focus({ preventScroll: true });
    } catch (err) {
      firstAlert.scrollIntoView();
    }
  }


  /* ------------------------------------------------------------------
     4. 一键复制（WhatsApp 号码 / 邮箱）
        优先 Clipboard API，失败时回退到临时 textarea
     ------------------------------------------------------------------ */
  function legacyCopy(text) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '-1000px';
    document.body.appendChild(area);
    area.select();
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (err) {
      ok = false;
    }
    document.body.removeChild(area);
    return ok;
  }

  function copyText(text, done) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () {
        if (legacyCopy(text)) done();
      });
      return;
    }
    if (legacyCopy(text)) done();
  }

  Array.prototype.forEach.call(root.querySelectorAll('.dd-copy'), function (btn) {
    var label = btn.querySelector('.dd-copy__label');
    var originalText = label ? label.textContent : '';
    var timer = null;

    btn.addEventListener('click', function () {
      // 复制的就是页面上展示的那串号码/邮箱，不再额外用属性传一遍
      var valueBox = btn.closest('.dd-method__value');
      var valueEl = valueBox ? valueBox.querySelector('.dd-method__value-text') : null;
      var value = valueEl ? valueEl.textContent.trim() : '';
      if (!value) return;

      var doneText = decodeEntities(
        btn.closest('.dd-method--wa') ? CONFIG.copiedNumber : CONFIG.copiedEmail
      );

      copyText(value, function () {
        btn.classList.add('is-copied');
        if (label && doneText) label.textContent = doneText;
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          btn.classList.remove('is-copied');
          if (label) label.textContent = originalText;
        }, 2200);
      });
    });
  });


  /* ------------------------------------------------------------------
     5. 唤起站点右下角的在线聊天 / WhatsApp 悬浮组件
        站点用的是第三方 App（Shopify Inbox / Tidio / Crisp / tawk.to 等），
        这里按「先调 API，再点 DOM」的顺序尝试；都找不到时高亮右下角提示用户
     ------------------------------------------------------------------ */
  var toast = root.querySelector('[data-dd-chat-toast]');
  var cornerCue = root.querySelector('[data-dd-corner-cue]');
  var hideTimer = null;

  function showCornerHint() {
    if (!toast && !cornerCue) return;
    if (toast) {
      toast.hidden = false;
      toast.classList.add('is-visible');
    }
    if (cornerCue) {
      cornerCue.hidden = false;
      cornerCue.classList.add('is-visible');
    }
    if (hideTimer) clearTimeout(hideTimer);
    hideTimer = setTimeout(hideCornerHint, 9000);
  }

  function hideCornerHint() {
    if (toast) {
      toast.classList.remove('is-visible');
      toast.hidden = true;
    }
    if (cornerCue) {
      cornerCue.classList.remove('is-visible');
      cornerCue.hidden = true;
    }
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
  }

  // 第三方聊天组件普遍提供打开窗口的 JS API
  function openViaApi() {
    var attempts = [
      function () { if (window.tidioChatApi && window.tidioChatApi.open) { window.tidioChatApi.open(); return true; } },
      function () { if (window.$crisp && window.$crisp.push) { window.$crisp.push(['do', 'chat:open']); return true; } },
      function () { if (window.Tawk_API && window.Tawk_API.maximize) { window.Tawk_API.maximize(); return true; } },
      function () { if (window.zE) { window.zE('messenger', 'open'); return true; } },
      function () { if (window.GorgiasChat && window.GorgiasChat.open) { window.GorgiasChat.open(); return true; } },
      function () { if (window.LiveChatWidget && window.LiveChatWidget.call) { window.LiveChatWidget.call('maximize'); return true; } },
      function () { if (window.Intercom) { window.Intercom('show'); return true; } },
      function () { if (window.ShopifyChat && window.ShopifyChat.Open) { window.ShopifyChat.Open(); return true; } }
    ];

    for (var i = 0; i < attempts.length; i++) {
      try {
        if (attempts[i]()) return true;
      } catch (err) {
        /* 单个 API 失败不影响后续尝试 */
      }
    }
    return false;
  }

  // 找不到 API 时，退一步尝试点击页面上疑似「聊天 / WhatsApp 悬浮按钮」的元素
  function clickLauncher(kind) {
    var selectors = kind === 'whatsapp'
      ? ['a[href*="wa.me"]', 'a[href*="whatsapp"]', '[class*="whatsapp" i]', '[id*="whatsapp" i]']
      : [
          '#tidio-chat',
          '#launcher',
          '[id*="shopify-chat" i]',
          '[class*="chat-launcher" i]',
          '[class*="chat-widget" i] > button',
          '[id*="chat" i] button',
          '[class*="chat" i][class*="button" i]',
          'button[aria-label*="chat" i]'
        ];

    for (var i = 0; i < selectors.length; i++) {
      var nodes;
      try {
        nodes = document.querySelectorAll(selectors[i]);
      } catch (err) {
        continue;
      }

      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];

        // 只点视口右下角的悬浮元素，避免误点页面正文里的链接
        var rect = el.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) continue;
        if (rect.left < window.innerWidth * 0.55 || rect.top < window.innerHeight * 0.45) continue;
        if (el.closest('.dd-contact')) continue;

        try {
          el.click();
          return true;
        } catch (err) {
          /* 继续找下一个 */
        }
      }
    }
    return false;
  }

  function openChat(kind) {
    // WhatsApp 卡片只想要 WhatsApp 通道：先点右下角 WhatsApp 悬浮按钮，再退回通用聊天 API
    if (kind === 'whatsapp') return clickLauncher('whatsapp') || openViaApi();
    if (openViaApi()) return true;
    return clickLauncher(kind);
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-dd-chat-trigger]'), function (btn) {
    btn.addEventListener('click', function () {
      var kind = btn.getAttribute('data-dd-chat-kind') || 'chat';

      // 站点自定义了聊天链接时优先跳转
      if (kind === 'chat' && CONFIG.chatUrl) {
        window.open(CONFIG.chatUrl, '_blank', 'noopener');
        return;
      }

      hideCornerHint();
      if (!openChat(kind)) showCornerHint();
    });
  });

  document.addEventListener('click', function (event) {
    if (!toast || toast.hidden) return;
    if (event.target.closest('[data-dd-chat-trigger], .dd-chat-toast')) return;
    hideCornerHint();
  });


  /* ------------------------------------------------------------------
     6. 订阅表单（JSON POST 到 Dianda 独立接口 /api/create-subscribe）
        请求体 { entry: 2, email }：entry 由接口约定固定为 2（联系页来源）
     ------------------------------------------------------------------ */
  var newsForm = root.querySelector('#dd-contact-newsletter-form');

  if (newsForm) {
    var newsCfg = window.ddNewsletterConfig || {};
    var newsMsgs = decodeMessages(newsCfg.messages);
    var newsEmail = newsForm.querySelector('input[name="email"]');
    var newsBtn = newsForm.querySelector('.dd-news__btn');
    var newsBtnText = newsForm.querySelector('.dd-news__btn-text');
    var newsStatus = newsForm.querySelector('#ddNewsStatus');
    // 按钮文案来自 Liquid，先存下来，提交期间临时替换成「Subscribing…」
    var newsBtnLabel = newsBtnText ? newsBtnText.textContent.trim() : '';
    var newsBusy = false;

    function newsShowStatus(kind, msg) {
      if (!newsStatus) return;
      newsStatus.hidden = !msg;
      newsStatus.className = 'dd-alert' + (msg ? ' dd-alert--' + kind : '');
      newsStatus.textContent = msg || '';
    }

    function newsSetBusy(on) {
      newsBusy = on;
      if (newsBtn) newsBtn.disabled = on;
      if (newsBtnText) newsBtnText.textContent = on ? (newsMsgs.submitting || newsBtnLabel) : newsBtnLabel;
    }

    function newsIsEmail(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
    }

    if (newsEmail) {
      newsEmail.addEventListener('input', function () {
        newsEmail.classList.remove('is-invalid');
        newsEmail.removeAttribute('aria-invalid');
      });
    }

    newsForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (newsBusy) return;

      var email = newsEmail ? newsEmail.value.trim() : '';
      if (!newsIsEmail(email)) {
        if (newsEmail) {
          newsEmail.classList.add('is-invalid');
          newsEmail.setAttribute('aria-invalid', 'true');
          newsEmail.focus();
        }
        newsShowStatus('error', newsMsgs.invalidEmail || 'Please enter a valid email address.');
        return;
      }

      if (!newsCfg.apiUrl) {
        // 静默失败会让用户以为按钮坏了，必须给出可见反馈
        console.error('[dd-contact] 未配置订阅接口地址，表单无法提交。');
        newsShowStatus('error', newsMsgs.error || 'Subscription failed. Please try again later.');
        return;
      }

      newsShowStatus('', '');
      newsSetBusy(true);

      fetch(newsCfg.apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          entry: 2,
          email: email,
        }),
      })
        .then(function (res) {
          // 沿用留咨接口的响应约定 {code, msg, errors}，把失败原因照实转达；
          // 跨域被拦（本地预览）时没有可读的响应体，退回调用方给的通用文案。
          return res.text().then(function (text) {
            var data = null;
            try { data = JSON.parse(text); } catch (_) {}
            var code = data && data.code != null ? Number(data.code) : null;
            if (res.ok && (code === null || code < 400)) return;
            var detail = data && data.errors && data.errors.length
              ? data.errors.join(' / ')
              : ((data && data.msg) || ('HTTP ' + res.status));
            var err = new Error(detail);
            err.serverMsg = detail;
            throw err;
          });
        })
        .then(function () {
          newsSetBusy(false);
          newsForm.reset();
          newsShowStatus('success', newsMsgs.success);
        })
        .catch(function (err) {
          newsSetBusy(false);
          newsShowStatus('error', (err && err.serverMsg) || newsMsgs.error || 'Subscription failed. Please try again later.');
          console.error('[dd-contact] 订阅提交失败：', err);
        });
    });
  }
})();
